import { OVERVIEW_TOURS } from './overview';
import { EQUITY_TOURS } from './equity';
import { DEBT_TOURS } from './debt';
import { GOLD_TOURS } from './gold';
import { OTHER_TOURS } from './others';

// All Investments tours, merged into TOURS in ../tours.js.
// overview.js: Investments overview + asset-class landing pages.
// The other files hold the product-page tours for their asset class(es).
export const INVESTMENT_TOURS = {
  ...OVERVIEW_TOURS,
  ...EQUITY_TOURS,
  ...DEBT_TOURS,
  ...GOLD_TOURS,
  ...OTHER_TOURS,
};
